import { render, staticRenderFns } from "./DownloadScormSuccess.vue?vue&type=template&id=1124c190"
import script from "./DownloadScormSuccess.vue?vue&type=script&lang=js"
export * from "./DownloadScormSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports